import { SVGProps } from 'react';

import theme from '@styles/theme';

export const FilterIcon = ({
  width = '17',
  height = '15',
  stroke = theme.palette.text[0],
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
    viewBox='0 0 17 15'
    {...props}
  >
    <path
      stroke={stroke}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.3'
      d='M14.817 3.15H5.65m-4.167 8.333h9.167m-5.732-10.1a2.5 2.5 0 1 1-3.536 3.535 2.5 2.5 0 0 1 3.536-3.536m10 8.332a2.5 2.5 0 1 1-3.536 3.536 2.5 2.5 0 0 1 3.536-3.536'
    ></path>
  </svg>
);
